import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getMypageUser } from "../../../../services/apiStudent";

const User = () => {
  // ユーザーデータ
  const [Data, setData] = useState([]);

  // 初期レンダリング
  useEffect(() => {
    (async function () {
      const data = await getMypageUser();
      if (data == undefined || !data) return;
      setData(data);
    })();
  }, []);

  return (
    <>
      {Data ? (
        <div className="l-page-right">
          <div className="l-page-con">
            <h1 className="p-heading01">ユーザー情報の確認・変更</h1>
            <div className="p-user-link">
              <div className="p-user-link-item">
                <a
                  className="p-user-link01"
                  href={
                    process.env.REACT_APP_SHIBUKATSU_WEB_DOMAIN +
                    "/mypage-manual/"
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  使い方を見る（新しいウィンドウで開きます）
                </a>
              </div>
              <div className="p-user-link-item">
                <Link className="p-user-link02" to="/mypage/user/update">
                  ユーザー情報を変更する
                </Link>
              </div>
            </div>
            <div className="p-user-con01">
              <h2 className="p-user-ttl">ユーザー情報</h2>
              <table className="p-user-tbl">
                <tbody>
                  <tr>
                    <th>学生番号</th>
                    <td>{Data.login_id}</td>
                  </tr>
                  <tr>
                    <th>氏名</th>
                    <td>{Data.name}</td>
                  </tr>
                  <tr>
                    <th>氏名カナ</th>
                    <td>{Data.name_kana}</td>
                  </tr>
                  <tr>
                    <th>生年月日</th>
                    <td>{Data.birthday}</td>
                  </tr>
                  <tr>
                    <th>電話番号1</th>
                    <td>{Data.phone1}</td>
                  </tr>
                  <tr>
                    <th>メールアドレス1</th>
                    <td>{Data.mail1}</td>
                  </tr>
                  <tr>
                    <th>電話番号2</th>
                    <td>{Data.phone2}</td>
                  </tr>
                  <tr>
                    <th>メールアドレス2</th>
                    <td>{Data.mail2}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className="p-page-link01">
              <Link to="/mypage/user/password">
                <span>パスワードを変更する</span>
              </Link>
            </p>
            <div className="p-user-con02">
              <h2 className="p-user-ttl">住所</h2>
              <table className="p-user-tbl">
                <tbody>
                  <tr>
                    <th>郵便番号</th>
                    <td>{Data.postcode}</td>
                  </tr>
                  <tr>
                    <th>住所</th>
                    <td>{Data.address}</td>
                  </tr>
                </tbody>
              </table>
              <h2 className="p-user-ttl p-user-ttl02">緊急連絡先</h2>
              <table className="p-user-tbl">
                <tbody>
                  <tr>
                    <th>氏名</th>
                    <td>{Data.emergency_name}</td>
                  </tr>
                  <tr>
                    <th>続柄</th>
                    <td>{Data.emereletion}</td>
                  </tr>
                  <tr>
                    <th>電話番号</th>
                    <td>{Data.emergency_phone}</td>
                  </tr>
                </tbody>
              </table>
              <div className="mt-5">
                ※住所や緊急連絡先等の変更が必要になった場合は、下記リンクをご確認ください。
                <p>
                  <a
                    href={process.env.REACT_APP_SHIBUKATSU_WEB_DOMAIN + "/faq/"}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    よくある質問（新しいウィンドウで開きます）
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};
export default User;
